import { RoundedBox } from '@react-three/drei'
import { Vector3 } from 'three'
import { Helper } from '../../../../classes/helper'
import { useMeasures } from '../../../../hooks/state/useMeasures'
import { useRoof } from '../../../../hooks/state/useRoof'
import { CachedMeshPhysicalMaterial } from '../../../material/cachedMeshPhysicalMaterial'
import { useSidewall } from '../../../../hooks/state/useSidewall'

interface StaticCarrierProps {
  height: number
  depth: number
  isBackside?: boolean
}

export const StaticsCarrier = ({
  height,
  depth,
  isBackside = false,
}: StaticCarrierProps): JSX.Element | null => {
  const {
    userWidth,
    userAngle,
    eaves,
    eavesWidth,
    userHeight,
    attachedBarSize,
  } = useMeasures()
  const { color } = useRoof()

  const position = isBackside
    ? new Vector3(0, userHeight - height / 2, depth / 2)
    : new Vector3(
        0,
        eaves
          ? Helper.calculateTriangle(eavesWidth, userAngle, 90).b -
            height / 2 -
            Helper.calculateTriangle(height, userAngle, 90).b / 2
          : -height / 2,
        (eaves ? -eavesWidth : 0) - depth / 2
      )

  return (
    <mesh position={position} castShadow={true} receiveShadow={false}>
      <RoundedBox
        args={[userWidth!, height, depth]}
        radius={0.0005}
        smoothness={0.5}
        castShadow={true}
        matrixWorldAutoUpdate={undefined}
        getObjectsByProperty={undefined}
        getVertexPosition={undefined}
      >
        <CachedMeshPhysicalMaterial color={color} />
      </RoundedBox>
    </mesh>
  )
}
